module.exports = __webpack_public_path__ + "img/OPEN_DETAILED_VIEW.8ac8e704.svg";